<template>
  <a-form
    :model="formState"
    style="position: relative"
    ref="formRef"
    :labelCol="labelCol"
    :wrapperCol="wrapperCol"
    labelAlign="right"
    class="action_form"
  >
  <!-- :labelCol="labelCol" -->
  <!-- :wrapperCol="wrapperCol" -->
    <template v-for="item in props.collection" :key="item.field">
        <a-form-item
          :label="item.label"
          v-if="!item.hidden"
          :style="{
            // width: item.width || props.itemWidth,
            width: '100%',
            height: ['image', 'imgUpload', 'textarea'].includes(item.type) ? 'auto' : itemHeight,
            position: 'relative',
          }"
          :required="item.required === undefined ? true : item.required"
        >
          <template v-if="item.tips">
            <a-popover title="提示">
              <template #content>
                <p v-for="tips in item.tips" :key="tips">{{ tips }}</p>
              </template>
              <QuestionCircleTwoTone
                style="position: absolute; left: -15px; top: 8px"
              />
            </a-popover>
          </template>
          <template v-if="item.type === 'inputNumber'">
            <InputNumber v-bind="item" v-model="formState[item.field]" />
          </template>
          <template v-else-if="item.type === 'inputPassword'">
            <InputPassword v-bind="item" v-model="formState[item.field]" />
          </template>
          <template v-else-if="item.type === 'select'">
            <Select
              v-bind="item"
              v-model="formState[item.field]"
              :options="item.options || getOption(item)"
            />
          </template>
          <template v-else-if="item.type === 'radio'">
            <Radio
              v-bind="item"
              v-model="formState[item.field]"
              :options="item.options || getOption(item)"
            />
          </template>
          <template v-else-if="item.type === 'dateRange'">
            <DateRange
              v-bind="item"
              v-model:start="formState[item.startField]"
              v-model:end="formState[item.endField]"
              :disabledDate="props.disabledDate"
              :disabled="formState[item.disabled]"
            />
          </template>
          <template v-else-if="item.type === 'addressPicker'">
            <AddressPicker
              v-bind="item"
              v-model:lat="formState[item.latField]"
              v-model:lng="formState[item.lngField]"
            />
          </template>
          <template v-else-if="item.type === 'imgUpload'">
            <ImgUpload v-bind="item" v-model="formState[item.field]" />
          </template>
          <template v-else-if="item.type === 'image'">
            <ImagePreview v-bind="item" v-model="formState[item.field]" />
          </template>
          <template v-else-if="item.type === 'fileUpload'">
            <FileUpload v-bind="item" v-model="formState[item.field]" />
          </template>
          <template v-else-if="item.type === 'date'">
            <DatePicker v-bind="item" v-model="formState[item.field]" />
          </template>
          <template v-else-if="item.type === 'textarea'">
            <Textarea
              v-bind="item"
              v-model="formState[item.field]"
              :auto-size="{ minRows: 6, maxRows: 6 }"
            >
            </Textarea>
          </template>
          <template v-else>
            <Input v-bind="item" v-model="formState[item.field]" />
          </template>
        </a-form-item>
    </template>
    <slot></slot>
  </a-form>
</template>

<script setup>
  import {
    reactive,
    defineProps,
    defineEmits,
    defineExpose,
    toRefs,
    ref,
    watch,
    nextTick,
    computed,
  } from 'vue'
  import Input from '@/components/form/input'
  import Textarea from '@/components/form/textarea'
  import InputNumber from '@/components/form/input_number'
  import InputPassword from '@/components/form/input_password'
  import Select from '@/components/form/select'
  import Radio from '@/components/form/radio'
  import DatePicker from '@/components/form/date'
  import AddressPicker from '@/components/form/address_picker'
  import { useStore } from 'vuex'
  import DateRange from '@/components/form/date_range'
  import { constantToOptions } from '@/utils/format'
  import { QuestionCircleTwoTone } from '@ant-design/icons-vue'
  import ImgUpload from '@/components/form/img_upload'
  import ImagePreview from '@/components/form/image_preview'
  import FileUpload from '@/components/form/file_upload'
  //初始化
  const props = defineProps({
    itemWidth: {
      type: String,
      default: '100%',
    },
    itemHeight: {
      type: String,
      default: 'auto',
    },
    itemCol: {
      type: Number,
      default: 8,
    },
    labelCol: {
      type: Object,
      default: () => ({ span: 7, offset: 0 }),
    },
    wrapperCol: {
      type: Object,
      default: () => ({ offset: 0 }),
    },
    disabledDate: Function,
    disabled: {
      type: Boolean,
      default: false,
    },
    submitInObject: Boolean, //提交表单时，数据是否放在一个对象内
    collection: Array,
    fetchData: Function,
    handelSearch: Function,
    handelAdd: Function,
  })
  const formRef = ref()
  const emit = defineEmits()
  const formState = reactive(getDefaultState(props.collection))

  function getDefaultState(collection) {
    const defaultState = {}
    collection.forEach((item) => {
      //处理特殊情况
      if (item.type === 'dateRange') {
        defaultState[item.startField] = item.defaultStart
        defaultState[item.endField] = item.defaultEnd
        defaultState[item.disabled] = item.disabled
      } else if (item.type === 'addressPicker') {
        defaultState[item.latField] = item.defaultLat
        defaultState[item.lngField] = item.defaultLng
      } else if (item.type === 'radio' || item.type === 'select') {
        //value转字符串
        defaultState[item.field] =
          item.defaultValue !== undefined ? item.defaultValue + '' : ''
      } else {
        //正常情况
        defaultState[item.field] = item.defaultValue ?? ''
      }
    })
    return defaultState
  }

  defineExpose({
    formState,
    submitInObject: props.submitInObject,
  })

  //获取store中的option数据
  const store = useStore()
  const Enum = toRefs(store.state?.common)
  function getOption({
    storeOptions,
    getName = false,
    filterNegative = false,
  } = {}) {
    if (Enum[storeOptions])
      return constantToOptions(Enum[storeOptions].value, {
        filterNegative,
        getName,
      })
    else return []
  }
</script>

<style lang="less" scoped></style>
